import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./routes";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { tracking_id } from "./utils/helper";
import { Provider } from "react-redux";
import store from "./store/store";
import ScrollToTop from "./components/ScrollToTop";
import ReactGA from "react-ga";
import GoogleAnalyticsReporter from "./utils/GoogleAnalyticsReporter";
import { BrandingProvider } from "./context/BrandingContext";
import { ThemeProvider } from "./themes/ThemeContext";
import { LocaleProvider } from "./i18n";

const trackingId = tracking_id;

// Inicializar ReactGA con el ID de seguimiento
ReactGA.initialize(trackingId);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <Provider store={store}>
      <BrandingProvider>
        <LocaleProvider>
          <ThemeProvider>
            <BrowserRouter>
              <ScrollToTop />
              <GoogleAnalyticsReporter trackingId={trackingId} />
              <App />
            </BrowserRouter>
          </ThemeProvider>
        </LocaleProvider>
      </BrandingProvider>
    </Provider>
  </AuthProvider>
);
